import axios from 'axios';
import config from '../config';

const GetAll = async (page, count, keyword) => {
    try {
        const token = localStorage.getItem("oojwt");
        const response = await axios.get(config.apiUrl + 'user-refer/all?page=' + page + '&resultCount=' + count + '&keyword=' + keyword, {
            headers: {
                'Authorization': 'Bearer ' + token
            }
        });
        if (response.status === 200) {
            console.log(response.data);
            return {
                status: 200,
                userRefers: response.data.userRefers,
                total: response.data.pagination.totalResults,
                totalPages: response.data.pagination.totalPages
            };
        }
    } catch (error) {
        console.log(error);
        return {
            status: 401,
            message: error.response.data.message
        };
    }
}

const GetByUserId = async (userId, page, count, keyword) => {
    try {
        const token = localStorage.getItem("oojwt");
        const response = await axios.get(
            `${config.apiUrl}user-refer/get-by-user-id?userId=${userId}&page=${page}&resultCount=${count}&keyword=${keyword}`,
            {
                headers: {
                    'Authorization': 'Bearer ' + token
                }
            }
        );
        console.log("Response status:", response);
        if (response.status === 200) {
            const pagination = response.data.pagination || {};
            return {
                status: 200,
                userRefers: response.data.userRefers,
                sponsorMobile: response.data.sponsorMobile,
                total: pagination.totalResults || 0,
                totalPages: pagination.totalPages || 0
            };
        }
    } catch (error) {
        console.log(error);
        return {
            status: 401,
            message: error?.response?.data?.message || "Something went wrong"
        };
    }
};

const UpdateSponsor = async (userId, newReferUserMobile) => {
    try {
        const data = new FormData();
        data.append("userId", userId);
        data.append("newReferUserMobile", newReferUserMobile);

        const token = localStorage.getItem("oojwt");
        const response = await axios.get(config.apiUrl + 'user-refer/update-sponsor?userId=' + userId + '&newReferUserMobile=' + newReferUserMobile, {
            headers: {
                'Authorization': 'Bearer ' + token
            }
        });

        console.log("UpdateSponsor Response:", response);

        if (response.status === 200) {
            return {
                status: 200,
                message: "Sponsor updated successfully"
            };
        }
        return {
            status: 400,
            message: "Sponsor update failed"
        };
    } catch (error) {
        return {
            status: error.response.status,
            message: "Sponsor update failed"
        };
    }
};


export { GetAll, GetByUserId, UpdateSponsor };

